export const MedicalReason = {
    path: '/medical_reasons',
    name: 'medical_reasons',
    component: () => import('@/views/Medical/Reason/MedicalReasonPage.vue'),
    children: [
        {
            path: '/medical_reasons/add',
            name: 'medical_reasons.add',
            component: () => import('@/views/Medical/Reason/Form/MedicalReasonForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/medical_reasons/edit/:id',
            name: 'medical_reasons.edit',
            component: () => import('@/views/Medical/Reason/Form/MedicalReasonForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/medical_reasons/delete/:id',
            name: 'medical_reasons.delete',
            component: () => import('@/views/Medical/Reason/Form/MedicalReasonForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/medical_reasons/view/:id',
            name: 'medical_reasons.view',
            component: () => import('@/views/Medical/Reason/Form/MedicalReasonForm.vue'),
            props: {viewAction: true}
        }
    ]
}